import usersIcon from "./users.png";

export const items = [
  {
    id: 1,
    text: "Ovo je tekst za prvi element",
    //date: new Date("October 13, 2014 11:13:00"),
    date: new Date(2024, 9, 13, 11, 13, 0),
    users: [],
    locations: [],
    categories: [],
    isBookmarked: true,
  },
  {
    id: 2,
    text: "Ovo je tekst za drugi element",
    //date: new Date("October 14, 2024 11:20:00"),
    date: new Date(2024, 9, 14, 11, 20, 0),
    users: ["Korisnik"],
    categories: [],
    locations: [],
    isBookmarked: false,
  },
  {
    id: 3,
    text: "Ovo je tekst za treci element",
    //date: new Date("October 17, 2024 20:53:00"),
    date: new Date(2024, 9, 17, 20, 53, 0),
    users: [],
    categories: [],
    locations: ["Lokacija"],
    isBookmarked: true,
  },
  {
    id: 4,
    text: "Ovo je tekst za cetvrti element",
    //date: new Date("October 18, 2024 15:13:00"),
    date: new Date(2024, 9, 18, 15, 13, 0),
    users: [],
    categories: [],
    locations: ["Lokacija"],
    isBookmarked: false,
  },
  {
    id: 5,
    text: "Ovo je tekst za prvi element",
    //date: new Date("October 13, 2014 11:13:00"),
    date: new Date(2024, 8, 13, 11, 13, 0),
    users: ["Korisnik"],
    categories: [],
    locations: [],
    isBookmarked: true,
  },
  {
    id: 6,
    text: "Ovo je tekst za prvi element",
    //date: new Date("October 13, 2014 11:13:00"),
    date: new Date(2024, 8, 13, 20, 13, 0),
    users: ["Korisnik"],
    locations: ["Lokacija"],
    categories: [],
    isBookmarked: true,
  },
];

export const users = [
  {
    name: "Petar Petrovic",
    fromLocation: true,
  },
  {
    name: "Jovan Jovanovic",
    fromLocation: true,
  },
  {
    name: "Zikica Petkovic",
    fromLocation: true,
  },
  {
    name: "Marko Nikolic",
    fromLocation: false,
  },
];

export const locations = [
  {
    name: "Moderatorova lokacija",
    fromLocation: true,
  },
  {
    name: "Druge iz naloga",
    fromLocation: true,
  },
  {
    name: "Proslava NG",
    fromLocation: false,
  },
  {
    name: "Trg kralja Milana",
    fromLocation: false,
  },
];

export const categories = [
  {
    name: "Radnici",
    icon: usersIcon,
  },
  {
    name: "Masine",
    icon: usersIcon,
  },
  {
    name: "Instalacije",
    icon: usersIcon,
  },
];
